import React from 'react';
import { call } from '../utilities/http';
import { FormattedMessage } from 'react-intl';
import {
    LOADING,
    COMPLETE,
    CLIENTS_GET_OK,
    CLIENTS_GET_WORKERS_OK,
    WORKER_UPDATE_OK,
    SAVING,
    CLIENT_GET_FEES_OK,
    CLIENT_FEE_CREATE_OK,
    CLIENT_FEE_UPDATE_OK,
    CLIENT_FEE_DELETE_OK
} from './types';
import { Snackbar } from '../components/snackbar';

const defaultState = {
    list: undefined,
    workers: undefined,
    fees: undefined
};

/**
 * Invites state mapper.
 * @param {object} state
 * @param {string} action
 */
export default function(state = defaultState, action) {
    switch (action.type) {
        case CLIENTS_GET_OK:
            return { ...state, list: action.data };

        case WORKER_UPDATE_OK:
            const workers = state.workers.filter(j => j.id !== action.data.id);
            const job = state.workers.find(j => j.id === action.data.id);
            const index = state.workers.indexOf(job);
            workers.splice(index, 0, { ...job, ...action.data });
            return { ...state, workers: [...workers] };

        case CLIENTS_GET_WORKERS_OK:
            return { ...state, workers: action.data };

        case CLIENT_GET_FEES_OK:
            const { data, id } = action;
            const fees = state.fees ? { ...state.fees } : {};
            fees[id] = data;
            return { ...state, fees };

        default:
            return state;
    }
}

export function getClients(adminId, status = 'current', onSuccess = result => null, extended = false) {
    let errorMessage = <FormattedMessage id={'error.getClients'} defaultMessage={'Unable to retrieve clients.'} />;

    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/admin/${adminId}/clients?status=${status}&extended=${extended ? 'true' : 'false'}` })
            .then(response => {
                dispatch({ type: CLIENTS_GET_OK, data: response });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}

export function getClientWorkers(clientId, filter = () => true, status = undefined, onSuccess = result => null) {
    let errorMessage = <FormattedMessage id={'error.getClientWorkers'} defaultMessage={'Unable to fetch client worker list.'} />;

    return async function(dispatch) {
        dispatch({ type: LOADING });

        const path = `/client/${clientId}/jobs?extended=true&limit=1000` + (status ? `&status=${status}` : '');
        call({ path })
            .then(response => {
                dispatch({ type: CLIENTS_GET_WORKERS_OK, data: response ? response.filter(filter) : [] });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}

export function getClientFees(clientId, onSuccess = result => null) {
    let errorMessage = <FormattedMessage id={'error.getClientFees'} defaultMessage={'Unable to fetch client fees list.'} />;

    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/client/${clientId}/fee_rules` })
            .then(response => {
                dispatch({ type: CLIENT_GET_FEES_OK, data: response, id: clientId });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}

export function updateClientWorker(worker, onSuccess = response => null) {
    let errorMessage = <FormattedMessage id={'error.updateJob'} defaultMessage={'Unable to update job record.'} />;

    return async function(dispatch) {
        dispatch({ type: SAVING });
        call({ path: `/job/${worker.id}`, method: 'PUT', body: worker })
            .then(response => {
                dispatch({ type: COMPLETE });
                dispatch({ type: WORKER_UPDATE_OK, data: worker });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}

export function createFee(fee, onSuccess = response => null) {
    let errorMessage = <FormattedMessage id={'error.createFee'} defaultMessage={'Unable to create fee rule.'} />;

    return async function(dispatch) {
        dispatch({ type: SAVING });
        call({ path: `/fee_rule`, method: 'POST', body: fee })
            .then(response => {
                dispatch({ type: COMPLETE });
                dispatch({ type: CLIENT_FEE_CREATE_OK, data: response });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}
export function updateFee(fee, onSuccess = response => null) {
    let errorMessage = <FormattedMessage id={'error.updateFee'} defaultMessage={'Unable to update fee rule.'} />;

    return async function(dispatch) {
        dispatch({ type: SAVING });
        call({ path: `/fee_rule/${fee.id}`, method: 'PUT', body: fee })
            .then(response => {
                dispatch({ type: COMPLETE });
                dispatch({ type: CLIENT_FEE_UPDATE_OK, data: fee });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}
export function deleteFee(fee, onSuccess = response => null) {
    let errorMessage = <FormattedMessage id={'error.deleteFee'} defaultMessage={'Unable to delete fee rule.'} />;

    return async function(dispatch) {
        dispatch({ type: SAVING });
        call({ path: `/fee_rule/${fee.id}`, method: 'DELETE' })
            .then(response => {
                dispatch({ type: COMPLETE });
                dispatch({ type: CLIENT_FEE_DELETE_OK, data: fee });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}



// WEBPACK FOOTER //
// ./src/reducers/clients.jsx